export default "__VITE_ASSET__CE0pCN68__"